import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types.ts';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import {
	CreateOrganizationCustomFieldDto,
	OrganizationCustomFieldResponseDto,
	OrganizationKycSettingResponseDto,
	UpdateOrganizationCustomFieldDto,
	UpdateOrganizationKycSettingDto,
} from '@dealstack/shared/lib/generated';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';

export const getOrganizationKycSetting = async (
	organizationId: string,
	options?: ServiceRequestOptions
) => {
	return await makeRequest<{ payload: OrganizationKycSettingResponseDto | null }>(
		{
			endpoint: formatUnicorn(API_PATHS.PROGRAMME_DEFAULTS_KYC_SETTING_ORGANIZATIONID_GET, {
				organizationId,
			}),
			method: HTTP_METHOD.GET,
		},
		{
			...options,
		}
	);
};

export const getOrganizationCustomFields = async (
	organizationId: string,
	options?: ServiceRequestOptions
) => {
	return await makeRequest<{ payload: OrganizationCustomFieldResponseDto[] }>(
		{
			endpoint: formatUnicorn(API_PATHS.PROGRAMME_DEFAULTS_CUSTOM_FIELD_ORGANIZATIONID_GET, {
				organizationId,
			}),
			method: HTTP_METHOD.GET,
		},
		{
			...options,
		}
	);
};

export const createOrganizationCustomField = async ({
	organizationId,
	body,
}: {
	organizationId: string;
	body: CreateOrganizationCustomFieldDto;
}) => {
	return await makeRequest({
		endpoint: formatUnicorn(API_PATHS.PROGRAMME_DEFAULTS_CUSTOM_FIELD_ORGANIZATIONID_POST, {
			organizationId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	});
};

export const updateOrganizationCustomField = async ({
	organizationId,
	customFieldId,
	body,
}: {
	organizationId: string;
	customFieldId: string;
	body: UpdateOrganizationCustomFieldDto;
}) => {
	return await makeRequest({
		endpoint: formatUnicorn(
			API_PATHS.PROGRAMME_DEFAULTS_CUSTOM_FIELD_ORGANIZATIONID_CUSTOMFIELDID_PUT,
			{ organizationId, customFieldId }
		),
		method: HTTP_METHOD.PUT,
		body: JSON.stringify(body),
	});
};

export const deleteOrganizationCustomField = async ({
	organizationId,
	customFieldId,
}: {
	organizationId: string;
	customFieldId: string;
}) => {
	return await makeRequest({
		endpoint: formatUnicorn(
			API_PATHS.PROGRAMME_DEFAULTS_CUSTOM_FIELD_ORGANIZATIONID_CUSTOMFIELDID_DELETE,
			{ organizationId, customFieldId }
		),
		method: HTTP_METHOD.DELETE,
	});
};

export const updateOrganizationKycSetting = async ({
	organizationId,
	body,
}: {
	organizationId: string;
	body: UpdateOrganizationKycSettingDto;
}) => {
	return await makeRequest({
		endpoint: formatUnicorn(API_PATHS.PROGRAMME_DEFAULTS_KYC_SETTING_ORGANIZATIONID_PUT, {
			organizationId,
		}),
		method: HTTP_METHOD.PUT,
		body: JSON.stringify(body),
	});
};
